import React from "react";

function BikePro() {
  return (
    <div className="w-full mx-auto space-y-5">
      {/* Brand Intro */}
      <div className="bg-gray-50 p-6 rounded-xl shadow-sm">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">BikePro</h1>
        <p className="text-gray-700 leading-relaxed text-base">
          <strong>BikePro</strong> is the brand name of Rider Bikes. Rider Bikes
          Pvt Ltd has perfected the craft of manufacturing bicycle components
          over the past five decades. Renowned for its reliable and affordable
          products, the company consistently delivers high-quality workmanship
          that meets international standards. They are the only manufacturer of
          Bicycle Sealed Cartridge Bottom Bracket and Alloy Hubs in India.
        </p>
      </div>

      {/* Product Line */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Product Line
        </h2>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-1">
          <li>BB Cartridges</li>
          <li>BB Semi Cartridge</li>
          <li>Headsets</li>
          <li>Alloy Hubs</li>
        </ul>
      </div>

      {/* Key Highlights */}
      <div className="max-sm:px-4">
        <h2 className="text-xl font-semibold text-gray-900 mb-1">
          Key Highlights
        </h2>
        <ul className="list-disc pl-6 text-gray-700 text-sm space-y-2">
          <li>
            <strong className="text-gray-900">Exclusive Supplier:</strong> Rider
            Bikes Pvt Ltd is the only supplier of BB Cartridges throughout
            India.
          </li>
          <li>
            <strong className="text-gray-900">Global Reach:</strong> BikePro
            products are exported to countries such as Sri Lanka, Poland,
            Colombia, Germany, and Australia.
          </li>
          <li>
            <strong className="text-gray-900">Superior Quality:</strong>{" "}
            BikePro’s quality surpasses most competitors, offering the best
            quality at the most competitive rates.
          </li>
          <li>
            <strong className="text-gray-900">Certification:</strong> BikePro
            products are ISO 9001 certified and in the process of attaining IATF
            16949:2016 certification.
          </li>
          <li>
            <strong className="text-gray-900">Quality Assurance:</strong> The
            company believes in rigorous self-inspection to maintain quality and
            production standards, adhering to CQI-9 and CQI-11 guidelines.
          </li>
        </ul>
      </div>
    </div>
  );
}

export default BikePro;
